// Always-visible sync indicator (REQ-UX-06): online or offline, and the changes and files waiting to sync.
import { useLiveQuery } from "dexie-react-hooks";
import { CloudOff, Cloud, RefreshCw } from "lucide-react";
import { db } from "./db";
import { waitingCount } from "./waiting";
import { useOnline } from "./useOnline";
import { cx } from "../ui/primitives";

export function SyncIndicator() {
  const online = useOnline();
  // Decision 84 #1: files still on the phone count too, so a file that has not left the phone is never invisible; round 3
  // (AT-029 / AT-095): a file a waiting change refers to is part of that change, not counted again.
  const count = useLiveQuery(waitingCount, [], { changes: 0, files: 0 });
  const waiting = count.changes + count.files;
  const rejected = useLiveQuery(() => db.outbox.where("status").equals("rejected").count(), [], 0);
  const label = online ? (waiting ? `Online, ${waiting} waiting to sync` : "Online") : `Offline${waiting ? `, ${waiting} waiting to sync` : ""}`;
  return (
    <div role="status" aria-live="polite" data-testid="sync-indicator" aria-label={label}
      className={cx("flex min-h-[36px] shrink-0 items-center gap-1.5 rounded-full border px-3 text-[13px] font-medium",
        online ? "border-success/30 bg-success/10 text-[rgb(var(--c-success-text))]" : "border-warning/40 bg-warning/15 text-[rgb(var(--c-warning-text))]")}>
      {online ? (waiting ? <RefreshCw className="h-4 w-4 animate-spin [animation-duration:2s]" aria-hidden /> : <Cloud className="h-4 w-4" aria-hidden />) : <CloudOff className="h-4 w-4" aria-hidden />}
      <span>{online ? "Online" : "Offline"}</span>
      {waiting > 0 && <span className="rounded-full bg-current/10 px-1.5 tabular-nums" data-testid="sync-waiting">{waiting}</span>}
      {rejected > 0 && <span className="sr-only">{rejected} changes could not be saved</span>}
    </div>
  );
}
